import React from "react";
import t from "../../../../i18n";
import ReportingErrorIndicator from "../ReportingErrorIndicator";
import { uniq } from "diagnostics-lib/array";
import type { Reporting } from "../../../../api/useReporting";
import { useProjectsDisplayDraft } from "../../../../api/useReporting";

function PerformanceChartSubtitle({
  reporting,
  extraInfo,
}: {
  reporting: Reporting;
  extraInfo?: string;
}) {
  const [draft] = useProjectsDisplayDraft();

  const chartSubtitleOptions = React.useMemo(() => {
    if (!reporting) return null;
    const projects = Object.values(reporting.projectById);
    const siteIds = uniq(projects.flatMap(({ siteId }) => (siteId ? [siteId] : [])));

    return {
      includedProjectCount: projects.length,
      siteCount: siteIds.length,
    };
  }, [reporting]);

  return chartSubtitleOptions ? (
    <>
      {t("reporting.chart.subtitle", {
        ...chartSubtitleOptions,
        draft,
      })}
      {extraInfo && <> — {extraInfo}</>}
      <ReportingErrorIndicator reporting={reporting} />
    </>
  ) : null;
}

export default React.memo(PerformanceChartSubtitle);
